import { useEffect, useState } from 'react';

export function useCountdown(endsAt?: string | Date | null) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!endsAt) return;
    const id = window.setInterval(() => setNow(Date.now()), 200);
    return () => window.clearInterval(id);
  }, [endsAt]);

  if (!endsAt) {
    return { remainingMs: null, remainingRatio: null };
  }
  const end = new Date(endsAt).getTime();
  const remainingMs = Math.max(0, end - now);
  return { remainingMs, remainingRatio: remainingMs };
}

export function countdownRatio(remainingMs: number | null, totalMs: number) {
  if (remainingMs == null || totalMs <= 0) return 0;
  return Math.max(0, Math.min(1, remainingMs / totalMs));
}
